
import React from "react";
import moment from "moment";

import GoBack from "../../../components/go-back";
import SelectBox from "../../../components/select-box/select-box";
import MainButton from "../../../components/main-button";
import InputBox from "../../../components/input-box/input-box";
import MainModal from "../../../components/main-modal";
import WebText from "../../../components/components-text/web-text";
import LeftInfoModal from "../../../components/left-info-modal";
import { PermissionsContainer } from "./permissions-style";
import { images } from "../../../assets";

import { PRODUCT_CARD_NAME_COLOR } from "../../../constants/policyType";
import { withGeneral } from "../../../context/mixin/with-general";
import ProductsMediadoresServices from "../../../services/ProductsMediadoresServices";
import ProductServices from "../../../services/ProductServices";
import MediatorServices from "../../../services/MediatorServices";
import { PermissionsProps, PermissionsState, Product, ProductAux, ProductMediator } from "./permissions-types";

class PermissionsLayout extends React.Component<PermissionsProps, PermissionsState> {
  constructor(props: PermissionsProps) {
    super(props);
    this.state = {
      auxProductMediadores: [],
      products: [],
      mediadoresProducts: [],
      selected: [],
      filter: {
        mediatorCode: '',
        selectedProductsId: [],
      },
      searched: false,
      validateSave: false,
      allSelected: false,
      errorModal: {
        active: false,
        mainTitle: "",
        mainText: "",
      },
    }
  }

  async componentDidMount() {
    const products = await ProductServices.getProductsByName({
      setLoading: this.props.setLoading,
    })
    this.setState({ products })
  }
  
  procesarIncluidos = (producto_mediador?: ProductMediator) => {
    if (producto_mediador) {
      return !!producto_mediador.esIncluido
    }
    return true;
  }

  procesaroNoIncluidos = (producto_mediador?: ProductMediator) => {
    if (producto_mediador) {
      return !!producto_mediador.esIncluido
    }
    return false;
  }

  async getAllUsers() {
    try {
      await MediatorServices.getMediatorInfo({
        setLoading: () => { },
        loader: true,
        mediatorCode: this.state.filter.mediatorCode,
        productPermissionCheck: true
      });
    } catch (error) {
      this.setState({
        mediadoresProducts: [],
        auxProductMediadores: [],
        errorModal: {
          active: true,
          mainTitle: "Mediador no encontrado",
          mainText: `El mediador ${this.state.filter.mediatorCode} no existe.`,
        },
        searched: false,
      });
      return
    }

    const allowedProductsIds: number[] = [];
    const response = await ProductServices.getAllowedProductsByRole({
      loader: true,
      setLoading: this.props.setLoading,
      mediatorId: this.state.filter.mediatorCode,
    });

    if (response.ok) {
      allowedProductsIds.push(...response.data);
    } else {
      this.setState({
        errorModal: {
          active: true,
          mainTitle: "Error en la recuperación de permisos",
          mainText: response.message,
        },
        mediadoresProducts: [],
        auxProductMediadores: [],
        searched: false,
      });
      return;
    }

    const args = {
      setLoading: () => { },
      loader: true,
      params: { mediatorCode: this.state.filter.mediatorCode, productos: this.state.filter.selectedProductsId }
    };

    const resp: ProductMediator[]  = await ProductsMediadoresServices.getUsers(args);
    //Tengo tanto los productos como los products mediadores
    //Tengo que guardar un array de objetos en el que guarde el estado del producto teniendo en cuenta
    let obj: ProductAux[] = []
    const { products, filter } = this.state;

    let temp_products = products;

    if (filter.selectedProductsId.length > 0) {
      const productFilters = products.filter((prod: Product) => filter.selectedProductsId.includes(prod.id));
      temp_products = productFilters;
    }

    temp_products.map((prod: Product, index: number) => {
      let product_mediador = resp.find((pm: ProductMediator) => prod.id === pm.productoId)
      let permiso = false;
      const allowedByRol = allowedProductsIds.includes(prod.id);

      if (allowedByRol) {
        permiso = this.procesarIncluidos(product_mediador);
      } else {
        permiso = this.procesaroNoIncluidos(product_mediador);
      }

      let aux_producto: ProductAux = {
        index,
        mediador: filter.mediatorCode,
        permiso,
        producto_id: prod.id,
        areaName: prod.areaName,
        internalName: prod.internalName,
        name: prod.name,
        modify: false,
        allowedByRol,
        producto_mediador_id: -1,
        createdAt: product_mediador ? moment(product_mediador.createdAt).format('DD/MM/YYYY HH:mm') : '',
        updatedAt: product_mediador ? moment(product_mediador.updatedAt).format('DD/MM/YYYY HH:mm') : '',
        colectivo: prod.colectivo,
        combinacion_comercial: prod.combinacion_comercial,
        cardName: prod.cardName,
      }
      if (product_mediador) {
        aux_producto.producto_mediador_id = product_mediador.id;
      }
      obj.push(aux_producto);
    })
    if (obj.length > 0) {
      this.setState({ mediadoresProducts: resp, auxProductMediadores: obj, searched: true })
    } else {
      this.setState({ mediadoresProducts: resp, auxProductMediadores: [], searched: true })
    }
  }

  async activatePermissionById(productsModified: ProductAux[]) {
    const args = {
      setLoading: () => { },
      loader: true,
      request: productsModified
    };
    const resp = await ProductsMediadoresServices.updatePermissions(args);
    if (resp) { this.getAllUsers() }
  }

  handleSave = () => {
    if (this.state.auxProductMediadores.length > 0) {
      this.setState({ validateSave: true })
    }
  }

  savePermissions = () => {
    const { auxProductMediadores } = this.state;
    const productsModified = auxProductMediadores.filter((prod: ProductAux) => prod.modify);
    this.activatePermissionById(productsModified)
    this.setState({ validateSave: true })
  }

  handleFilter = () => {
    if (this.state.filter.mediatorCode !== '') {
      this.getAllUsers();
    }
  }

  handleChangeProducts(values: number[]) {
    this.setState((prevState) => ({
      filter: { ...prevState.filter, selectedProductsId: values }
    }));
  }

  handleChangeFilterMediatorCode = (value: string) => {
    this.setState((prevState) => ({
      filter: { ...prevState.filter, mediatorCode: value },
    }));
  }

  handleBlurFilterMediatorCode = (value: string) => {
    const val = value.replace(/ +/g, '');
    this.handleChangeFilterMediatorCode(val)
  }

  handleEsIncluidoTable = (id: number) => {
    let { mediadoresProducts, selected } = this.state;
    const target = mediadoresProducts.find((prod: ProductMediator) => prod.id === id);

    if (target) {
      target.esIncluido = Number(!target.esIncluido);
      target.modify = !target.modify
    }

    const selectedTarget = selected.find((item) => item.id === id)

    if (selectedTarget) {
      selected.splice(selected.findIndex((item) => item.id === id), 1);
    } else if (target) {
      selected.push(target)
    }
    this.setState({ selected })
  }

  closeModal = () => {
    this.setState({ validateSave: false });
  };

  closeErrorModal = () => {
    this.handleChangeFilterMediatorCode('')
    this.setState({ 
      errorModal: {
        active: false,
        mainTitle: "",
        mainText: ""
      },
      searched: false
    });
  } 

  handlePermiso = (product: ProductAux) => {
    const { auxProductMediadores } = this.state;
    auxProductMediadores[product.index].permiso = !auxProductMediadores[product.index].permiso;
    auxProductMediadores[product.index].modify = true;
    this.setState({
      auxProductMediadores
    });
  }

  seleccionarTodos = () => {
    const { auxProductMediadores, allSelected } = this.state;
    const permiso = !allSelected
    for (let i = 0; i < auxProductMediadores.length; i++) {
      if (auxProductMediadores[i].permiso !== permiso) {
        auxProductMediadores[i].permiso = permiso;
        auxProductMediadores[i].modify = true;

      }
    }
    this.setState({ auxProductMediadores, allSelected: permiso });
  }

  checkDisabled = () => {
    const { auxProductMediadores } = this.state;
    return !auxProductMediadores.some((p: ProductAux) => p.modify === true)
  }

  render() {
    const {
      products,
      filter,
      searched,
      validateSave,
      auxProductMediadores,
      allSelected,
      errorModal
    } = this.state;
    const { selectedProductsId } = filter

    return (
      <PermissionsContainer>
        <div className="go-back-head">
          <GoBack />
        </div>
        <div className="permission-content"></div>
        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h2>CONFIGURAR PERMISOS DE USUARIOS</h2>
          </div>
        </div>
        <div className="data-wrapper">
          <div className="content-wrapper bottomMargin40">
            <div className="personal-data-wrapper">
              <div className="data-title">
                <h3> Filtrar </h3>
              </div>


              <div className="permission-columns-container">
                <div className="permission-column">
                  <div className="permission-row first-row">
                    <div className="inputBox">
                      <InputBox
                        required={true}
                        onChange={(value: string) => this.handleChangeFilterMediatorCode(value)}
                        onBlur={(value: string) => this.handleBlurFilterMediatorCode(value)}
                        placeholder="Mediador"
                        type={"text"}
                        value={this.state.filter.mediatorCode}
                      />
                    </div>
                  </div>
                  <div className="permission-row">
                    <div className="inputBox">
                      {products.length > 0 &&
                        <SelectBox
                          selectedMultipleOptions={selectedProductsId as unknown as string[]}
                          multiple={true}
                          placeholder="Todos los productos"
                          optionsText={products as unknown as {[key: string]: string}[]}
                          optionKey={"id"}
                          optionValue={"name"}
                          onMultipleChange={(values) =>
                            this.handleChangeProducts(
                              values as unknown as number[]
                            )
                          }
                          onChange={() => { }}
                        />
                      }
                    </div>
                  </div>
                  <div className="data-row colSin-100">
                    <div className="left-align">
                      <div className="inputBoxSearch">
                        <div className="add-permission-modal-button    filter-search-button">
                          <MainButton icon={true} iconImg={images.IconSearchWhite} disabled={false} text={"Buscar"} onClick={() => this.handleFilter()} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {(auxProductMediadores.length === 0 && !searched) ? <></> :
                (auxProductMediadores.length === 0 && searched) ? <span> No se han encontrado registros </span> :
                  <>
                    <div className="selectAllButton">
                      <MainButton disabled={false} text={(allSelected) ? "Eliminar todos" : "Seleccionar Todos"} onClick={() => this.seleccionarTodos()} />
                    </div>
                    <div className="permissions-table-container">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Producto Id</th>
                            <th>Mediador</th>
                            <th>Producto</th>
                            <th>Colectivo</th>
                            <th>Combinación comercial</th>
                            <th>Creado</th>
                            <th>Actualizado</th>
                            <th>Estado de Permiso</th>                          
                          </tr>
                        </thead>
                        <tbody>
                          {
                            auxProductMediadores.map((product: ProductAux, index: number) => {
                              return <tr className="main-table-row" key={index}>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.producto_id}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.mediador}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <WebText className={`normal tag-container ${PRODUCT_CARD_NAME_COLOR[product.cardName]}`}>
                                    <p className={(product.modify ? 'modificado' : '')} >{product.name}</p>
                                  </WebText>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.colectivo}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.combinacion_comercial}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.createdAt}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <p className={(product.modify ? 'modificado' : '')} >{product.updatedAt}</p>
                                </td>
                                <td className={(product.modify ? 'fondo-modificado' : '')}>
                                  <div>
                                    <span onClick={() => this.handlePermiso(product)}>
                                      <div className={"dicotomic " + (product.permiso ? 'active' : 'inactive')}>
                                        <div className="checkbox-container">
                                          <div className="checkmark-container">
                                            <img src={product.permiso ? images.IconTickWhite : images.IconCloseBlue} alt="" />
                                          </div>
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                </td>

                              </tr>
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    <div className="save-footer">
                      <div className="save-text">
                        <p>Para actualizar los datos es necesario guardar</p>
                      </div>
                      <div className="data-row colSin-100">
                        <div className="left-align">
                          <div className="inputBoxSearch">
                            <div className="add-permission-modal-button">
                              <MainButton disabled={this.checkDisabled()} text={"Guardar"} onClick={() => this.handleSave()} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
              }
            </div>
          </div>
        </div>
        <div className="hr" />
        {validateSave && (
          <MainModal
            mainTitle="Los permisos de este usuario se van a modificiar. ¿Desea continuar?"
            buttonText={"Aceptar"}
            centered={true}
            active={validateSave}
            img={images.IconWarningYellow}
            className={"warning"}
            close={() => this.closeModal()}
            onClickAccept={() => this.savePermissions()}
          />
        )}
        <LeftInfoModal
          img={images.WarningError}
          className="error"
          mainTitle={errorModal.mainTitle}
          mainText={errorModal.mainText}
          buttonText={"Cerrar"}
          active={errorModal.active}
          onClickAccept={() => this.closeErrorModal()}
          close={() => this.closeErrorModal()}
          noSecondaryButton
        />
      </PermissionsContainer>
    )
  }
}

export default withGeneral(PermissionsLayout);
